import { fetch } from '@financial-tool/fetch';
import { Expense, NewExpenseVersion } from '../types/expense';

export default function createNewExpenseVersionAPI(id: string, newVersion: NewExpenseVersion) {
  return fetch.post<Expense>(`/expenses/${id}/versions`, newVersion);
}
